export default __webpack_public_path__ + "static/media/Yurii.30898452.jpg";